import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
// -------Angular Material------------------------------------
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../shared-components/angular-material/mat-animations';
import { TabsComponent } from '../../shared-components/controls/tabs/tabs.component';
import { SharedService } from '../../shared-components/shared.service';
import { Attendance, AttendanceSchools, ExcessiveAttendance, SpecialAdditionalAttendance, StudentTeamAttendance } from '../../shared-components/student/attendance.model';
import { CourseSchedule } from '../../shared-components/student/course-schedule.model';
import { Enrollment } from '../../shared-components/student/enrollment.model';
import { Student } from '../../shared-components/student/student.model';
// ---------Shared--------------------------------------------
import { CheckInOutViewHistoryDialogComponent } from '../../shared-components/check-in-out-view-history-dialog/check-in-out-view-history-dialog.component';
import { SelfCheckInOutHistoryDialogComponent } from '../../shared-components/self-check-in-out-history-dialog/self-check-in-out-history-dialog.component';
import { StudentService } from '../../shared-components/student/student.service';
import { ViewAbsentNoticeHistoryDialogComponent } from '../../shared-components/view-absent-notice-history-dialog/view-absent-notice-history-dialog.component';
import { YearService } from '../../shared-components/year/year.service';
import { StudentSummaryService } from '../student-summary/student-summary.service';
import { ByDateTableComponent } from './by-date-table/by-date-table.component';
import { ByScheduleTableComponent } from './by-schedule-table/by-schedule-table.component';
import { BySpecialAdditionalComponent } from './by-special-additional/by-special-additional.component';
import { ByTeamTableComponent } from './by-team-table/by-team-table.component';
import { ByViewExcessiveComponent } from './by-view-excessive/by-view-excessive.component';
import { CodeLegendComponent } from './code-legend/code-legend.component';

@Component({
    selector: 'attendance',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './attendance.component.html',
    animations: [detailExpand],
})
export class AttendanceComponent implements OnInit, AfterViewInit, OnDestroy {

    // ------------Element references--------------------------------
    @ViewChild('appHeader') appHeaderRef: ElementRef;
    @ViewChild('studentHeader', { static: true }) studentHeaderRef: ElementRef;
    @ViewChild('tabs', { static: true }) tabsRef: ElementRef;
    @ViewChild('dropdown') dropdownRef: ElementRef;
    @ViewChild('footer', { static: true }) footerRef: ElementRef;
    appHeaderHeight = 0;
    studentHeaderHeight = 0;
    tabsHeight = 0;
    dropDownHeight = 0;
    footerHeight = 0;
    footerWidth = 0;
    // ------------Student Attendance Data---------------------------
    selectedStudentSubscription: Subscription;
    student360YearSubscription: Subscription;
    selectedStudent: Student;
    studentEnrollment: Enrollment;
    attendance: Attendance[];
    courseSchedules: CourseSchedule[];
    teamAttendance: StudentTeamAttendance[];
    // ------------Selection/Flags-----------------------------------
    AttendanceByDate = true;
    showAllCodes = false;
    selected = 'By Date';

    // -----------Grid functionality---------------------------------
    gridHeight = 0;
    // ------------Modal window--------------------------------------
    legendDialogRef: MatDialogRef<CodeLegendComponent>;
    // ----------Angular Material------------------------------------
    excessiveAttendanceAngularMatData = new TylerMatTableDataSource();
    @ViewChild(MatSort) sort: MatSort;
    initialSelection = [];
    allowMultiSelect = true;
    selection = new SelectionModel<any>(this.allowMultiSelect, this.initialSelection);
    @ViewChild(ByDateTableComponent) byDateTableRef: ByDateTableComponent;
    @ViewChild(ByScheduleTableComponent) byScheduleTableRef: ByScheduleTableComponent;
    @ViewChild(ByViewExcessiveComponent) byViewExcessiveTableRef: ByViewExcessiveComponent;
    @ViewChild(BySpecialAdditionalComponent) BySpecialAdditionalRef: BySpecialAdditionalComponent;
    @ViewChild(ByTeamTableComponent) byTeamTableRef: ByTeamTableComponent;
    // @ViewChildren(FilterComponent) filterRef: QueryList<FilterComponent>;
    toggleAllRows: EventEmitter<boolean> = new EventEmitter<boolean>();
    clearFilterEvent = new EventEmitter<any>();
    // -----------V9--------------------------------------------------
    tabNames: string[] = [];
    selectionIndex = 0;
    studentExcessiveAttendance: ExcessiveAttendance[] = [];
    excessiveAttendanceSchools: AttendanceSchools[] = [];
    studentSpecialAttendance: SpecialAdditionalAttendance[] = [];
    specialAdditionalAttendanceSchools: AttendanceSchools[] = [];
    studentTeamAttendance: StudentTeamAttendance[] = [];
    columnsToDisplayExcessiveAttendance = ['Steps', 'Points', 'AppealedStatus'];
    viewExcessiveAttendanceOptions: any[] = [];
    viewTrackingGroupsOptions: any[] = [];
    selectedExcessiveAttendanceOption = 0;
    selectedTrackingGroupOption = 0;
    attendanceDaysAndHoursInfo: any = [];
    setIndex = new EventEmitter<number>();
    isStudentTeamExists = false;
    calendarUseAttendanceTypes = false;

    showSelfCheckButton = false;
    showAbsentNoticeButton = false;
    loadStudentInfoCall = false

    @ViewChild(TabsComponent) tabs: TabsComponent;
    // --------------Lifecycle-------------------------------------
    constructor(
        private studentService: StudentService,
        private sharedService: SharedService,
        private dialog: MatDialog,
        private yearService: YearService,
        public changeDetector: ChangeDetectorRef,
        public route: ActivatedRoute,
        private studentSummaryService: StudentSummaryService
    ) {
        this.selectedStudentSubscription = studentService.selectedStudentStream$.subscribe(
            studentId => {
                if (studentId > 0 && this.loadStudentInfoCall == false) {
                    if (this.studentService.selected != undefined && this.studentService.selected != null) {
                        this.selected = this.studentService.selected;
                        this.studentService.selected = null;
                        this.loadStudentInfo(studentId, true);
                    }
                    else {
                        this.loadStudentInfo(studentId);
                    }
                }
            });

        this.student360YearSubscription = this.yearService.observableStudent360YearStream$.subscribe(() => {
            this.loadStudentInfo(this.studentService.selectedStudent.Id, true);
        });
        this.student360YearSubscription = this.studentService.observableStudentEnrollmentStream$.subscribe((enrollment) => {
            if (enrollment && this.loadStudentInfoCall == false) {
                this.loadStudentInfo(enrollment.StudentId, false);
            }
        });

        this.tabNames.push('REGULAR ABSENCES');
        this.tabNames.push('EXCESSIVE ABSENCES');
        this.tabNames.push('SPECIAL ADDITIONAL');
    }

    ngOnInit() {
        if (this.loadStudentInfoCall == false) {
            if (this.studentService.selected != undefined && this.studentService.selected != null) {
                this.selected = this.studentService.selected;
                this.studentService.selected = null;
            }
            this.loadStudentInfo(this.studentService.selectedStudent.Id, true);
        }
    }

    ngAfterViewInit() {
        if (this.studentHeaderRef != undefined) {
            this.studentHeaderHeight = this.studentHeaderRef.nativeElement.offsetHeight;
        }
        if (this.tabsRef != undefined) {
            this.tabsHeight = this.tabsRef.nativeElement.offsetHeight;
        }
        if (this.dropdownRef != undefined) {
            this.dropDownHeight = this.dropdownRef.nativeElement.offsetHeight;
        }
        if (this.footerRef != undefined) {
            this.footerHeight = this.footerRef.nativeElement.offsetHeight;
            this.footerWidth = this.footerRef.nativeElement.width;
        }
        this.studentService.selectionIndex = 0;
        this.onResize();
    }

    ngOnDestroy() {
        this.selectedStudentSubscription.unsubscribe();
        this.student360YearSubscription.unsubscribe();
    }

    // ------------Student Attendance Data---------------------------
    loadStudentInfo(studentId: number, maintainSelected = false) {
        this.loadStudentInfoCall = true;
        this.clearStudentData();
        this.selectedStudent = this.studentService.students.filter(function (student) { return student.Id == studentId; })[0];
        this.studentEnrollment = this.studentService.studentEnrollment;
        if (this.studentEnrollment != undefined && this.studentEnrollment != null) {
            this.getCheckInOutButtnSettings(this.studentEnrollment.StudentId, this.studentEnrollment.AcademicYearID);
        }
        if (!maintainSelected) {
            this.selected = 'By Date';
            setTimeout(() => {
                if (this.studentService.selectionIndex == 0) {
                    this.selectionIndex = 0;
                }
                else {
                    this.selectionIndex = this.studentService.selectionIndex;
                }
                this.setIndex.emit(this.selectionIndex);
                this.selectionChange(this.selectionIndex);
                this.tabs.selectedIndexChange(this.selectionIndex);
            }, 50);
        }

        this.getAttendanceDaysAndHoursInfo();
        this.getStudentAttendanceInfo();
        this.getSpecialAttendance();
        this.getCalendarUseAttendanceTypes();
    }

    getStudentAttendanceInfo() {
        if (this.selected == 'By Date') {
            this.attendance = undefined;
            this.studentService.getStudentAttendance(this.selectedStudent.Id, this.yearService.student360Year.Id, this.showAllCodes).subscribe(data => {
                this.attendance = [];
                data.forEach(element => {
                    this.attendance.push(element);
                });
            });
        }
        else if (this.selected == 'By Team') {
            this.studentTeamAttendance = undefined;
            this.studentService.getStudentTeamAttendanceAbsentTardiesCount(this.selectedStudent.Id, this.yearService.defaultYear.SchoolID, this.yearService.student360Year.Id).subscribe(data => {
                this.studentTeamAttendance = [];
                data.forEach(element => {
                    this.studentTeamAttendance.push(element);
                });
            });
        }
        else {
            this.courseSchedules = undefined;
            this.studentService.getStudentSchedule(this.selectedStudent.Id, this.yearService.student360Year.Id, parseInt(this.selected, 10), true, -1, true, false, false, this.showAllCodes).subscribe(data => {
                this.courseSchedules = [];
                data.forEach(element => {
                    element.CourseSection = element.SubjectCode + '-' + element.Section;
                    this.courseSchedules.push(element);
                });
            });
        }
    }

    getSpecialAttendance() {
        this.studentService.getSpecialAttendance(this.selectedStudent.Id, this.yearService.student360Year.Id).subscribe(data => {
            this.studentSpecialAttendance = data;
            this.loadStudentInfoCall = false;
        });
    }

    getCalendarUseAttendanceTypes() {
        this.sharedService.getCalendarUseAttendanceTypes(0, this.yearService.student360Year.Id, this.selectedStudent.Id).subscribe(result => {
            this.calendarUseAttendanceTypes = result;
        });
    }

    clearStudentData() {
        this.attendance = undefined;
        this.studentExcessiveAttendance = [];
        this.studentSpecialAttendance = [];
        this.selectionIndex = 0;
    }

    // ----------Angular Material------------------------------------
    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        setTimeout(() => {
            this.gridHeight = window.innerHeight - 67 - 30 - this.studentHeaderHeight - this.tabsHeight - this.dropDownHeight - this.footerHeight;
        }, 0);
    }

    // ------------Modal window-----------------------
    CodeLegendClick() {
        const codes: any[] = [];

        if (this.selectionIndex == 0) {
            if (this.selected == 'By Date') {
                this.attendance.forEach(function (attend) {
                    attend.AttendanceDetails.forEach(function (details) {
                        if (codes.map(function (e) { return e.Code; }).indexOf(details.AttendanceCode) == -1) {
                            codes.push({ 'Code': details.AttendanceCode, 'Description': details.AttendanceCodeDescription });
                        }
                    });
                });
            }
            else {
                this.courseSchedules.forEach(function (schedule) {
                    schedule.AttendanceDetails.forEach(function (details) {
                        if (codes.map(function (e) { return e.Code; }).indexOf(details.AttendanceCode) == -1) {
                            codes.push({ 'Code': details.AttendanceCode, 'Description': details.AttendanceCodeDescription });
                        }
                    });
                });
            }
        }
        else if (this.selectionIndex == 2) {
            this.studentSpecialAttendance.forEach(function (attend) {
                if (codes.map(function (e) { return e.Code; }).indexOf(attend.ReasonCode) == -1) {
                    codes.push({ 'Code': attend.ReasonCode, 'Description': attend.ReasonDescription });
                }
            });
        }

        this.legendDialogRef = this.dialog.open(CodeLegendComponent, {
            panelClass: 'tyl-mat-dialog',
            maxWidth: '510px',
            disableClose: true
        });

        this.legendDialogRef.componentInstance.attendanceCodes = codes.sort(this.codeSort);
        this.legendDialogRef.componentInstance.callbyAttendanceComponet = true;
        this.legendDialogRef.afterClosed().subscribe(result => { });
    }

    codeSort(a, b) {
        if (a.Code < b.Code) {
            return -1;
        }
        if (a.Code > b.Code) {
            return 1;
        }
        return 0;
    }

    clearFilter() {
        if (this.selected == 'By Date' && this.byDateTableRef != undefined) {
            this.byDateTableRef.angularMatData.removeAllFilters();
        }

        if (this.selected != 'By Date' && this.byDateTableRef != undefined) {
            this.byScheduleTableRef.angularMatData.removeAllFilters();
        }

        if (this.selected == 'By Team' && this.byTeamTableRef != undefined) {
            this.byTeamTableRef.angularMatData.removeAllFilters();
        }

        if (this.byViewExcessiveTableRef != undefined) {
            this.byViewExcessiveTableRef.excessiveAttendanceAngularMatData.removeAllFilters();
        }
        if (this.BySpecialAdditionalRef != undefined) {
            this.BySpecialAdditionalRef.specialAdditionalAttendanceAngularMatData.removeAllFilters();
        }
    }

    isFiltered(): boolean {
        let filtered: boolean;

        if (this.byDateTableRef != undefined) {
            if (this.byDateTableRef.angularMatData.isFiltered() && this.selected == 'By Date') {
                filtered = true;
            }
        }

        if (this.byScheduleTableRef != undefined) {
            if (this.byScheduleTableRef.angularMatData.isFiltered() && this.selected != 'By Date') {
                filtered = true;
            }
        }

        if (this.byTeamTableRef != undefined) {
            if (this.byTeamTableRef.angularMatData.isFiltered() && this.selected == 'By Team') {
                filtered = true;
            }
        }

        if (this.byViewExcessiveTableRef != undefined) {
            if (this.byViewExcessiveTableRef.excessiveAttendanceAngularMatData.isFiltered()) {
                filtered = true;
            }
        }
        if (this.BySpecialAdditionalRef != undefined) {
            if (this.BySpecialAdditionalRef.specialAdditionalAttendanceAngularMatData.isFiltered()) {
                filtered = true;
            }
        }
        return filtered;
    }

    // -------------V9-------------------------------------------------------
    selectionChange(selectionIndex: number) {
        this.selectionIndex = selectionIndex;
        this.studentService.selectionIndex = selectionIndex;
        this.onResize();
    }

    selectedExcessiveAttendanceChange(event) {
        this.selectedExcessiveAttendanceOption = event;
    }

    getAttendanceDaysAndHoursInfo() {
        this.studentService.getAttendanceDaysAndHoursInfo(this.selectedStudent.Id, this.yearService.student360Year.Id).subscribe(data => {
            this.attendanceDaysAndHoursInfo = data;
            this.loadStudentInfoCall = false;
        });
    }

    expandAll(expand: boolean) {
        if (this.selectionIndex == 0) {
            if (this.selected != 'By Date' && this.selected != 'By Team') {
                this.byScheduleTableRef.expandAll(expand);
            }
            else if (this.selected == 'By Date') {
                this.byDateTableRef.expandAll(expand);
            } else {
                this.byTeamTableRef.expandAll(expand);
            }
        }
        else if (this.selectionIndex == 1) {
            this.byViewExcessiveTableRef.expandAll(expand);
        }

    }

    getCheckInOutButtnSettings(studentId: number, yearId: number) {
        this.studentSummaryService.getCheckInOutButtonSettings(studentId, yearId).subscribe(settings => {
            if (settings.AllowParentEnterCheckInOut || settings.AllowParentEnterCheckInOutMobile || settings.AllowStudentEnterCheckInOut || settings.AllowStudentEnterCheckInOutMobile) {
                this.showSelfCheckButton = true;
            }

            if (settings.AllowParentEnterAbsentNotice || settings.AllowStudentEnterAbsentNotice) {
                this.showAbsentNoticeButton = true;
            }
        });
    }

    viewSelfCheckHistoryClick() {
        const dialogBox = this.dialog.open(SelfCheckInOutHistoryDialogComponent, {
            disableClose: true,
            minWidth: '60vw',
            maxWidth: '120vw',
            minHeight: '80vh',
            data: {
                studentId: this.selectedStudent.Id,
                selectedStudent: this.selectedStudent
            }
        });
    }

    viewAbsentNoticeClick() {
        const dialogBox = this.dialog.open(ViewAbsentNoticeHistoryDialogComponent, {
            disableClose: true,
            minWidth: '60vw',
            maxWidth: '60vw',
            minHeight: '80vh',
            data: {
                studentId: this.selectedStudent.Id,
                selectedStudent: this.selectedStudent
            }
        });
    }

    viewHistoryClick() {
        const dialogBox = this.dialog.open(CheckInOutViewHistoryDialogComponent, {
            disableClose: true,
            minWidth: '80vw',
            maxWidth: '80vw',
            minHeight: '80vh',
            data: {
                selectedStudent: this.selectedStudent,
                schoolId: this.studentEnrollment.SchoolId
            }
        });
    }
}
